/* Allow the keyboard-open warehouse menu to close with Escape or an outside click. */
(() => {
  const activeMenu = () => document.activeElement?.closest('.f-site-nav__item--mega');
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const item = activeMenu();
    if (!item) return;
    document.activeElement.blur();
  });
  document.addEventListener('pointerdown', event => {
    const item = activeMenu();
    if (item && !item.contains(event.target)) document.activeElement.blur();
  }, true);
})();
/* Native content disclosures: animate both directions, including interrupted clicks. */
(() => {
  const running = new WeakMap();
  document.addEventListener('click', event => {
    const summary = event.target.closest('summary');
    const item = summary?.parentElement;
    if (!item?.matches('details') || !item.matches('.wa-collection-story, .wa-dialog details')) return;
    if (event.target.closest('a,button,input') || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    event.preventDefault();
    const prior = running.get(item), expand = prior ? !prior.expand : !item.open;
    const start = item.getBoundingClientRect().height;
    prior?.animation.cancel();
    const saved = prior?.saved || {height:item.style.height,overflow:item.style.overflow,boxSizing:item.style.boxSizing};
    item.style.boxSizing = 'border-box';
    item.style.height = 'auto';
    item.open = expand;
    const end = item.getBoundingClientRect().height;
    item.open = true;
    item.style.height = start + 'px';
    item.style.overflow = 'hidden';
    const animation = item.animate([{height:start+'px'},{height:end+'px'}],{duration:Math.min(560,320+Math.abs(end-start)*.2),easing:'cubic-bezier(.22,.61,.36,1)',fill:'forwards'});
    running.set(item,{animation,expand,saved});
    animation.onfinish = () => {item.open=expand;Object.assign(item.style,saved);running.delete(item);animation.cancel();};
  });
})();
/* Translate only app-owned guest prompts; retain app links and event handlers. */
(() => {
 if (!document.documentElement.lang.startsWith('de')) return;
 const translations = new Map([
 ['Log in to keep your wishlist and access it anytime.','Melde dich an, um deine Wunschliste dauerhaft zu speichern.'],
 ['Log in to keep it permanently and sync across devices.','Anmelden und deine Wunschliste auf allen Geräten nutzen.'],
 ['Start Shopping','Whiskys entdecken']
 ]);
 const selector='.st-product-toast_sub-message, .st-wishlist-save-your-wishlist a, .st-wishlist-details_empty_actions a';
 function translate(root){
  const nodes=[...(root.matches?.(selector)?[root]:[]),...(root.querySelectorAll?.(selector)||[])];
  for(const node of nodes){const translated=translations.get(node.textContent.trim());if(translated)node.textContent=translated;}
 }
 translate(document);
 new MutationObserver(records=>{for(const record of records){if(record.type==='childList'){translate(record.target);for(const node of record.addedNodes)if(node.nodeType===1)translate(node);}}}).observe(document.body,{childList:true,subtree:true});
})();

/* Keep topic navigation smooth even when the theme handles generic anchors. */
document.addEventListener('click',event=>{const link=event.target.closest('[data-wa-faq-jump]');if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;const target=document.getElementById(link.hash.slice(1));if(!target)return;event.preventDefault();event.stopImmediatePropagation();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});history.replaceState(null,'',link.hash);},true);
